import script from "./folderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./folderModal.vue?vue&type=script&setup=true&lang=js"

import "./folderModal.vue?vue&type=style&index=0&id=3ae15ec8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ae15ec8"]])

export default __exports__